import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import RouteOverviewTreePopup, { typeOfRouteOverviewTreeDialog } from '@Pages/RetroSynthesis/RouteTree/components/RouteOverviewTreePopup';
import { ButtonWithIcon } from '@els/els-react--button';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { isPredictedRoute } from '@Pages/RetroSynthesis/ProjectRoute/selectors';
import { getProjectsInfoMap } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { onRouteViewClick } from '@Pages/RetroSynthesis/ProjectRoutes/analytics';
import { getProjectsRoutesDataResponseList } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';

import './RouteOverviewTreePopupContainer.scss';
/* eslint-disable no-shadow */
export const openRouteOverviewTreeDialog = ({ treeList, routeName, projectId, routeId }) =>
  updateDialog({
    id: typeOfRouteOverviewTreeDialog,
    typeOfRouteOverviewTreeDialog,
    dialogType: typeOfRouteOverviewTreeDialog,
    treeList,
    routeName,
    projectId,
    routeId,
  });

export function RouteOverviewTreePopupContainer({
  selfClose,
  treeList,
  routeName,
  projectId,
  routeId,
  isPredictedRoute,
  projectsInfo,
  routes,
}) {
  const history = useHistory();

  const navigateToRouteTreeView = () => {
    history.push(RsRoute.getProjectRouteTreeViewLink(projectId, routeId));
    const projectInfo = (projectsInfo && projectsInfo[projectId]) || {};
    onRouteViewClick(
      projectId,
      routes.filter((r) => routeId === r.id),
      projectInfo
    );
    selfClose();
  };

  return (
    <RouteOverviewTreePopup
      treeList={treeList}
      selfClose={selfClose}
      routeName={routeName}
      className="route-overview-tree-popup-container"
      footerClassName="route-overview-tree-popup-container__footer"
      footer={
        <ButtonWithIcon
          type="primary"
          size="small"
          sprite="ChevronRight"
          linkIconSize="s"
          iconRight
          onClick={navigateToRouteTreeView}
          className="e2e-view-in-tree-view">
          View in Tree view
        </ButtonWithIcon>
      }
      isPredictedRoute={isPredictedRoute}
    />
  );
}

const mapStateToProps = (state) => ({
  isPredictedRoute: isPredictedRoute(state),
  projectsInfo: getProjectsInfoMap(state),
  routes: getProjectsRoutesDataResponseList(state),
});
export default connect(mapStateToProps, null)(RouteOverviewTreePopupContainer);
